var map = {
	"./Data/CatalogPages/LoadCatalogPageByPath": 64113,
	"./Data/CatalogPages/LoadCatalogPageByPath.ts": 64113,
	"./Pages/Brands/LoadBrandsAlphabet": 20019,
	"./Pages/Brands/LoadBrandsAlphabet.ts": 20019,
	"./Pages/InvoiceDetails/ForceDisplayInvoice": 22002,
	"./Pages/InvoiceDetails/ForceDisplayInvoice.ts": 22002,
	"./XNG/Common": 54778,
	"./XNG/Common.ts": 54778,
	"./XNG/CreateAccount": 59892,
	"./XNG/CreateAccount.ts": 59892,
	"./XNG/Header": 96804,
	"./XNG/Header.ts": 96804,
	"./XNG/OrderHistoryStatus": 71868,
	"./XNG/OrderHistoryStatus.ts": 71868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17373;